export const onlyNumber: RegExp = /^[0-9]*$/;

//check mobile number
export function phoneNumberCheck(value: string): boolean {
  if (value.slice(0, 2) === "09" && value.length === 11) {
    return true;
  } else {
    return false;
  }
}

export function emailCheck(value: string): boolean {
  if (value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<;>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
    return true;
  } else {
    return false;
  }
}

export function thousandsSeperator(number:number | string , unit?:string) {
  if (unit===undefined){
    unit = ''
  } else {
    unit = ' ' + unit
  }
  return (number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + unit )
}

export function briefing(number:number , text:string) {
  if (text.length < number){
    return text
  } else {
    return text.substring(0,number) + ' ...'
  }
}